import React from 'react'
import PropTypes from 'prop-types'
import { TextField, InputAdornment } from '@mui/material'
import { AddCircle } from '@mui/icons-material'

const NotesInput = ({ notes, onClickNotes, sx, size }) => (
  <TextField
    label="Notes"
    sx={sx}
    size={size}
    value={notes.length > 0 ? notes?.[0]?.name : ''}
    onClick={onClickNotes}
    InputProps={{
      sx: {
        cursor: 'pointer',
        '& *': {
          cursor: 'pointer',
        },
      },
      readOnly: true,
      endAdornment: (
        <InputAdornment position="end">
          <AddCircle />
        </InputAdornment>
      ),
    }}
  />
)

NotesInput.propTypes = {
  sx: PropTypes.object,
  onClickNotes: PropTypes.func.isRequired,
  notes: PropTypes.array,
}

NotesInput.defaultProps = {
  notes: [],
  sx: {},
  size: 'medium',
}

export default NotesInput
